import { connect } from 'react-redux';
import OptionGroup from './OptionGroup';

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OptionGroup);



// WEBPACK FOOTER //
// ./src/components/OptionGroup/index.js